import { getProductStockSkus } from '../../services/api/productStock.api';
import { GET_STOCK_BROWSER_SKU_LIST_REQUEST, GET_STOCK_BROWSER_SKU_LIST_SUCCESS, GET_STOCK_BROWSER_SKU_LIST_FAILURE } from '../types';
import { transformStockSkus } from '../../transforms/stock';
import { transformPagination } from '../../transforms/pagination';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: transformStockSkus([]),
		pagination: transformPagination({}),
	},

	mutations: {
		[GET_STOCK_BROWSER_SKU_LIST_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = [];
		},
		[GET_STOCK_BROWSER_SKU_LIST_SUCCESS](state, { data, meta }) {
			state.isLoading = false;
			state.data = transformStockSkus(data);
			state.pagination = transformPagination(meta);
		},
		[GET_STOCK_BROWSER_SKU_LIST_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async getProductStockSkus({ commit }, _params = {}) {
			try {
				const params = {
					keyword: _params.keyword,
					'filters[brand_id]': _params.brand,
					'filters[status]': _params.status,
					'filters[product_type]': _params.type,
					'filters[channel_rule_id]': _params.channel_rule,
					'filters[stock_rule_id]': _params.stock_rule,
					sort_by: _params.sort_by,
					sort_direction: _params.sort_direction,
					page: _params.page,
					per_page: 30,
				};
				commit(GET_STOCK_BROWSER_SKU_LIST_REQUEST);
				const { data } = await getProductStockSkus(params);
				commit(GET_STOCK_BROWSER_SKU_LIST_SUCCESS, data);
			} catch (error) {
				commit(GET_STOCK_BROWSER_SKU_LIST_FAILURE, error);
			}
		},
	},
};
